import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import CKEditor from "react-ckeditor-component";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import $ from 'jquery';
import AutoComplete from 'material-ui/AutoComplete';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import MaintenanceWindow from '../MaintenanceWindow';
const dataSourceConfig = {
    text: 'title',
    value: 'id',
};

class NoteEdit extends Component {
    constructor(props) {
        super(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            owners: [],
            search: [],
            er_note_attachment: [],
            apiUrl: this.decryptconfigdata('apiUrl'),
            userId: has_local_data ? localdata.user_id : '',
            userName: has_local_data ? localdata.user_name : '',
            userAuthKey: has_local_data ? localdata.user_key : '',
            notedata: '',
            NoteEdit: localStorage.getItem('ticket_note'),
            message: '',
            imageupload: 1,
            is_note: 1,
            maintenanceWindow: 0
        }
        this.ckOnChange = this.ckOnChange.bind(this);
        this.getSearchERNumber = this.getSearchERNumber.bind(this);
        this.maintenance = this.maintenance.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    rawjsonparse(findresponse, flg) {
        return findresponse;
    }

    handleUpdateInput = (searchText) => {
        this.setState({
            searchText: searchText,
        });
        this.getERNumber(searchText);
    };

    handleNewRequest = (searchText) => {
        this.getSearchERNumber();
    };

    enterKeyPress(event) {
        if (event.key == 'Enter') {
        }
    }

    getERNumber(searchText = '') {
        fetch(this.state.apiUrl + '/ErRest/getERNumber/userAuthKey/' + this.state.userAuthKey + '/searchText/' + searchText, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({
                        search: findresponse.ers,
                        errorText: ''
                    })
                } else {
                    this.setState({ errorText: findresponse.msg })
                }

            })
    }
    getSearchERNumber() {
        fetch(this.state.apiUrl + '/ErRest/getSearchERNumber/userAuthKey/' + this.state.userAuthKey + '/search/' + this.state.searchText, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.code == 200) {
                    this.setState({
                        ers: findresponse.ers,
                        item_count: findresponse.item_count,
                    })
                    if (this.state.item_count > 0) {
                        window.location.href = '/viewER/' + findresponse.er_id;
                    }
                }
                else {
                    alert("No result found");
                }
            })
    }

    ckOnChange(evt) {
        
        var ckContent = evt.editor.getData();       
        var selection = evt.editor. getSelection();       
        var query='';
        var range = selection. getRanges()[0];
        if(range){
            var cursor_position = range.startOffset;
            var Current_string=range.startContainer.$.data;
            if(Current_string){
                var changedString=Current_string.substring(0, cursor_position);
                if(changedString.lastIndexOf('@')!=-1){
                    query=changedString.substring(changedString.lastIndexOf('@')+1);               
                   
                }           

            }
        }
        if (this.state.NoteEdit.toLowerCase() != ckContent.toLowerCase()) {
            this.setState({
                NoteEdit: ckContent
            });
            var obj = this;
            setTimeout(function () {
            ckContent = ckContent.replace(/<\/p>$/, "");
                    console.log(obj.state.owners);
                    if (query) {
                        var result = [];

                        var filterObj = obj.state.owners.filter(function (e) {
                            if (e.name.toLowerCase().includes(query.toLowerCase())) {
                                var data = [];
                                data['name'] = e.name;
                                data['email'] = e.email;
                                data['user_type'] = e.user_type;
                                data['id'] = e.id;
                                result.push(data);
                            }
                        });

                        var size = Object.keys(result).length;

                        var mtchitems = '';

                        if (size > 0) {

                            for (var i in result) {
                                mtchitems += '<li class="auto-suggest-li" style="padding:5px;cursor:pointer;background:#ccc;margin-bottom:1px;" data-id = "'+ result[i]['id'] +'" data-email = "'+ result[i]['email'] +'" data-user_type = "'+ result[i]['user_type'] +'"  >' + result[i]['name'] + '</li>';
                            }

                            mtchitems = '<ul style="list-style:none" class="auto-suggest-ul">' + mtchitems + '</ul>';

                            document.getElementById('note_autoseggestion').innerHTML = mtchitems;

                            $('.auto-suggest-li').on('click', function (event) {

                                var id = $(this).data('id');
                                var email = $(this).data('email');
                                var user_type = $(this).data('user_type');
                            
                                if(user_type == 0){

                                    var final_string = '<a href= "https://intranet.muvi.com/viewEmployee/'+ id +'" class="mentions" data-id = "'+ id +'" >@' +  event.target.innerText.trim() + '</a>';

                                }else{

                                    var final_string = '<a href= "https://intranet.muvi.com/viewGroups/'+ email +'" class="mentions" data-id = "'+ id +'" >@' +  event.target.innerText.trim() + '</a>';
                                }

                                evt.editor.insertHtml(final_string);
                                
                                final_string=evt.editor.getData();
                                var replaceQueryString=final_string.replace('@'+query,'');

                                evt.editor.setData(replaceQueryString);
                                
                                document.getElementById('note_autoseggestion').innerHTML = "";    
                                
                            });
                           
                        } else {
                            document.getElementById('note_autoseggestion').innerHTML = "";
                        }
                } else {
                    document.getElementById('note_autoseggestion').innerHTML = "";
                }
            }, 300);
        } else {
            evt.editor.focus();
        }
    }

    updateErNote() {
        document.getElementById("add_note").innerHTML = "Sending....";
        let img = document.getElementById('attachments').files.length;
        const fd = new FormData;
        if (img > 0) {
            for (var x = 0; x < img; x++) {
                fd.append("image[]", document.getElementById('attachments').files[x]);
            }
        }
        document.getElementById("add_note").disabled = true;

        fd.append('note', this.state.NoteEdit);
        fetch(this.state.apiUrl + '/ErRest/updateNoteEr/id/' + this.props.match.params.noteId + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                document.getElementById("add_note").disabled = false;
                document.getElementById("add_note").innerHTML = "update";
                if (findresponse.code == 200) {
                    this.setState({ message: findresponse.msg }, function () {
                        window.location.href = '/viewEr/' + this.state.note_er_id;
                    });
                } else {
                    this.setState({ message: findresponse.msg })
                }
            })
    }
    showImage(s3url) {
        window.open(s3url);
    }
    deleteNoteImage(id, er_id) {
        if (window.confirm('Are you sure to delete?')) {
            fetch(this.state.apiUrl + '/ErRest/deleteNoteImage/id/' + id + '/er_id/' + er_id + '/userAuthKey/' + this.state.userAuthKey + '/username/' + this.state.userName)
                .then((Response) => Response.json())
                .then((findresponse) => {
                    this.getnoteDetails();
                })
        }
    }

    getnoteDetails() {
        fetch(this.state.apiUrl + '/ErRest/NoteEdit/id/' + this.props.match.params.noteId + '/userAuthKey/' + this.state.userAuthKey)
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                this.setState({
                    NoteEdit: findresponse.notedetails,
                    note_er_id: findresponse.note_er_id,
                    er_note_attachment: findresponse.er_note_attachment,
                    owners: findresponse.owners,
                })
            })
    }

    back() {

        window.location.href = '/viewEr/';
    }


    componentWillMount() {

        document.title = "Intranet | Edit Note";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.getnoteDetails();
        $(document).ready(function () {
            $('.upload_btn label').click(function () {
                $('.upload_btn .inputfile').click();
            });
            $('.inputfile').each(function () {
                var $input = $(this),
                    $label = $input.next('label'),
                    labelVal = $label.html();

                $input.on('change', function (e) {
                    var fileName = '';

                    if (this.files && this.files.length > 1)
                        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                    else if (e.target.value)
                        fileName = e.target.value.split('\\').pop();

                    if (fileName)
                        $label.find('span').html(fileName);
                    else
                        $label.html(labelVal);
                });

                // Firefox bug fix
                $input
                    .on('focus', function () { $input.addClass('has-focus'); })
                    .on('blur', function () { $input.removeClass('has-focus'); });
            });
        });

    }

    maintenance(under_maintenance){
    if(under_maintenance == 1){
    this.setState({ 
        maintenanceWindow: under_maintenance 
    });
    }
    }
    
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }

        return (
            <div>
                        <MaintenanceWindow receive ={this.maintenance} />
                        {!this.state.maintenanceWindow ?
                                <div>
                <Header brecum_name="er" brecum_page="Note Detail" NoteEdit={this.state.NoteEdit} />
                <div class="right_col">
                    <div class="intranet_body">
                        <div class="title mob"><HeaderMob page_name="Update Note" /></div>
                        <div class="form-group">
                            <div class="react_auto">
                                <MuiThemeProvider muiTheme={getMuiTheme()}>
                                    <AutoComplete
                                        floatingLabelText="Search ticket number"
                                        onUpdateInput={this.handleUpdateInput}
                                        onNewRequest={this.handleNewRequest}
                                        fullWidth={true}
                                        placeholder='Search ER ID or Title'
                                        filter={AutoComplete.caseInsensitiveFilter}
                                        dataSource={this.state.search}
                                        dataSourceConfig={dataSourceConfig}
                                        errorText={this.state.errorText}
                                        maxSearchResults={8}
                                        onKeyPress={this.enterKeyPress}
                                        errorStyle={{ bottom: 0 }}
                                        className="ticket_search_box"
                                    />
                                </MuiThemeProvider>
                                <i class="fa fa-search"></i>
                            </div>
                        </div>
                        <div class="top-row-form">
                            <div class="form-group">
                                <label>Note<span class="star">*</span></label>
                                <CKEditor
                                    activeClass="p10"
                                    config={{
                                        extraAllowedContent : '*[*]{*}(*)'
                                    }}
                                    content={this.state.NoteEdit}
                                    events={{
                                        "change": this.ckOnChange
                                    }}
                                />
                                <div id='note_autoseggestion'></div>
                            </div>
                            <div class="details_des">
                                <span class="color-sky">
                                    {
                                        this.state.attachments ? this.state.attachments.split(",").map(place =>
                                            <div class="note_wrap" /*onClick={()=> this.showImage(this.state.attachment_url,place)}*/> {place} <div className="details_des delete">
                                                <span class="color-red" onClick={() => this.delteimage(this.state.attachment_url, place)} >
                                                    <i class="fa fa-trash"></i>
                                                </span>
                                            </div>
                                            </div>
                                        ) : ""
                                    }
                                </span>
                            </div>
                            <div class="upload">
                                <label>Add Attachment :</label>
                                <div class="upload_btn">
                                    <input type="file" name="attachments" id="attachments" class="inputfile inputfile-1" data-multiple-caption="{count} files selected" multiple />
                                    <label for="file-1">
                                        <i class="fa fa-plus hidden-sm" aria-hidden="true"></i>
                                        <span>Choose file</span>
                                        <i class="fa fa-cloud-upload-alt hidden-md" aria-hidden="true"></i>
                                    </label>
                                </div>
                            </div>
                            <div class="upload ">
                                <h4 class="pull-left border-bottom"></h4>
                                {
                                    this.state.er_note_attachment.map((data, key) =>
                                        <div class="attached attach_delete">
                                            <span onClick={() => this.showImage(data.url)}  >
                                                <i class="far fa-file"></i>{data.attachment_name}
                                            </span>
                                            <span class="delete" onClick={() => this.deleteNoteImage(data.id, data.entity_id)}  >
                                                <i class="fa fa-trash"></i>
                                            </span>
                                        </div>
                                    )}
                            </div>
                            <button type="submit" name="add_note" id="add_note" className="btn btn-sky mob-btn" onClick={() => this.updateErNote()}>Update</button>
                            <Link to={'/viewEr/' + this.state.note_er_id} name={"max"}> <button className="btn btn-blue">Back</button></Link>
                            <div className="clear"></div>
                        </div>
                    </div>

                    <span style={{ color: "red" }}>{this.state.message}</span>
                </div>
            </div>
            :
            ''   
            }
            </div>
        )
    }
}
export default NoteEdit;


// WEBPACK FOOTER //
// ./src/components/er/NoteEdit.js